(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchButton = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');

  const setExpanded = (button, panel, open) => {
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    body.classList.toggle('overlay-open', open);
  };

  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    setExpanded(menuButton, mobileMenu, open);
    if (open) setExpanded(searchButton, searchPanel, false);
  });

  searchButton?.addEventListener('click', () => {
    const open = searchButton.getAttribute('aria-expanded') !== 'true';
    setExpanded(searchButton, searchPanel, open);
    if (open) {
      setExpanded(menuButton, mobileMenu, false);
      window.setTimeout(() => searchPanel.querySelector('input')?.focus(), 60);
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    setExpanded(menuButton, mobileMenu, false);
    setExpanded(searchButton, searchPanel, false);
  });

  document.querySelectorAll('[data-quantity]').forEach(control => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      const step = button.dataset.quantityAction === 'increase' ? 1 : -1;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = option.dataset.price;
      const compare = option.dataset.compare;
      const available = option.dataset.available === 'true';
      const root = select.closest('[data-product-root]');
      if (!root) return;
      root.querySelector('[data-product-price]').textContent = price;
      const compareEl = root.querySelector('[data-product-compare]');
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }
      const button = root.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
    });
  });

  document.querySelectorAll('form.quick-add-form').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button');
      button.disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add product');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(result => result.json());
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        const toast = document.querySelector('[data-cart-toast]');
        toast?.classList.add('is-visible');
        window.setTimeout(() => toast?.classList.remove('is-visible'), 2200);
      } catch (_) {
        form.submit();
      } finally {
        button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
})();
